// extracted by mini-css-extract-plugin
export default {"advert":"Advert_advert__3WLIa","description":"Advert_description__T9Ph4"};